import { motion } from "framer-motion";

export default function AnimatedPage({ children }: any) {
	return (
		<motion.div
			initial={{ opacity: 0.7, x: 5 }}
			animate={{
				opacity: 1,
				x: 0,
				transition: { ease: "easeInOut", duration: 0.33 }
			}}
			exit={{
				opacity: 0.4,
				x: -100,
				transition: { ease: "easeInOut", duration: 0.1 }
			}}
			style={{ height: "100%", overflowY: "hidden" }}
		>
			{children}
		</motion.div>
	);
}
